







import { Component, Prop, Vue, Watch, Inject } from 'vue-property-decorator';

import Buttons from '../../ScoreInput/Buttons.vue';

import ClassItemRate from '../../../models/interfaces/ClassItemRate';
import ClassItem from '../../../models/interfaces/ClassItem';

import { Type as IndicatorsType } from '@solucx/indicators';
import { ClassRatingLike } from '../../../utils/ClassRatingLike';

@Component({ components: { Buttons } })
export default class ClassCSAT10 extends Vue {
  @Prop({ required: true })
  public readonly item!: ClassItem;

  @Prop({ required: true })
  public readonly value!: ClassItemRate;

  @Watch('value.score')
  public updateLike(score: number) {
    this.value.like = ClassRatingLike.getRatingLike(score, IndicatorsType.CSAT10);
    this.$emit('input', this.value);
  }
}
